<template>
  <label class="check-box" :class="dynamicClasses">
    <slot />
    <span class="check-box__slider" :class="{ 'check-box__slider--disabled': disable }"></span>
    <span v-if="label" class="check-box__label" :class="{ 'check-box__label--disabled': disable }">
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
    style: {
      type: String,
      default: "default"
    },
    label: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dynamicClasses() {
      return {
        "check-box--gray": this.style === "gray",
        "check-box--reverse-gray": this.style === "reverse-gray",
        "check-box--app-gray": this.style === "app-gray"
      };
    }
  }
};
</script>

<style scoped lang="scss">
@import "./check-box.scss";
</style>
